module.exports = __webpack_public_path__ + "img/home-homefitness.aa212363.jpg";